import React, { Component } from "react";
import Chart from "chart.js";
import { GetKPIData } from "../Actions/CommonAPI";

class NonHazardousChart extends Component {

  componentDidMount(){
    const { dashboardData } = this.props;
    this.createChart(dashboardData);
  }

  componentDidUpdate() {
    const { dashboardData } = this.props;
    this.createChart(dashboardData);
  }
  
  createChart(dashboardData) {

    var chart = this.refs.learner;
    let data = dashboardData ? [dashboardData.totalNonHazardousPOsValidated, dashboardData.totalNonHazardousPOsIdentified] : [0, 0]

    var newChart = new Chart(chart, {
      type: 'horizontalBar',
      data: {
          labels: ['Non Hazardous PO\'s validated', 'Non Hazardous PO\'x identified'],
          datasets: [{
              axis: 'y',
              label: 'KPI for Non Hazardous POs - Validated within 3 days',
              data: data,
              barPercentage: 0.3,
              backgroundColor: [
                  '#94cf50',
                  '#00b150',
              ],
              borderColor: [
                  '#94cf50',
                  '#00b150',
              ],
              borderWidth: 1
          }]
      },
      options: {
          scales: {
              y: {
                  beginAtZero: false
              },
              xAxes: [{
                ticks: {
                    min: 0, // Edit the value according to what you need
                },
                interval: 20
              }],
              yAxes: [{
                  stacked: true
              }]
          },
          indexAxis: 'y',
          legend: {
            onClick: (e) => e.stopPropagation()
        }
      }
  });
  
  }

  render() {

    return (
      // <div class="myChart">
        <canvas
          ref="learner"
          width="400" 
          height="250"
        ></canvas>
      // </div>
    );
  }
}

export default NonHazardousChart;
